import axios from 'axios';

export default axios.create({
    baseURL: 'http://unithon-env.xv7gsd9iec.us-east-2.elasticbeanstalk.com/api',
    timeout: 3000,
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json'
    }
})


// WEBPACK FOOTER //
// ./src/customAxios.js